import { render, staticRenderFns } from "./NotAllowed.vue?vue&type=template&id=401cef9b&scoped=true"
import script from "./NotAllowed.vue?vue&type=script&lang=js"
export * from "./NotAllowed.vue?vue&type=script&lang=js"
import style0 from "./NotAllowed.vue?vue&type=style&index=0&id=401cef9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401cef9b",
  null
  
)

export default component.exports